<template>
    <v-card v-if="is_load_data">

        <!-- <v-container> -->

        <v-card-title
            class="text_primary"
            style="border-bottom: 1px solid #ddd;"
        >

            {{card_title}}

            <v-spacer></v-spacer>

        </v-card-title>
            
        <!-- </v-container>             -->

        <v-card-text>
            
            <h6
                class="fw-700 pl-0 text-subtitle-2 mt-2"
            >
                {{ card_sub_title_name }}
            </h6>

            <p class="pl-0">
                {{ staff_info.user_name }}
            </p>

            <h6
                class="fw-700 pl-0 text-subtitle-2 mt-2"
            >
                {{ card_sub_title_email }}
            </h6>

            <p class="pl-0">
                {{ staff_info.email }}
            </p>

            <h6
                class="fw-700 pl-0 text-subtitle-2 mt-2 mb-1"
            >
                {{ card_sub_title_role }}
            </h6>

            <p
                style="width: 15em;"
                class="mb-0"
            >
                <v-select
                    @change="updateRole"
                    dense
                    v-model="staff_role"
                    outlined
                    :items="roles"
                    item-text="text"
                    item-value="value"
                    hide-details
                    return-object
                    :disabled="selectedOrg.org_role !== 'orgPrincipal'"
                >
                </v-select>

            </p>

        </v-card-text>
            
        <v-card-title
            class="text_primary"
            style="border-bottom: 1px solid #ddd;"
        >

            權限設定

            <v-spacer></v-spacer>

        </v-card-title>

        <v-tabs
            show-arrows
            center-active
            v-model="tab"
            color="primary"
        >

            <v-tab v-for="(item,index) in admin_edit_tabs" :key="item.title" :value="index">      
                {{ item.title }}
            </v-tab>

        </v-tabs>

        <v-tabs-items v-model="tab" color="blue darken-4">

            <ManageAdministrationPermissions
                ref="auth-tab"
                :auths="auth_items"
                :staff_info="staff_info"
                v-if="tab === 0"
                color="#0D47A1"
            />
            
            <!-- <ApiAuth
                v-if="tab === 1"
                color="#0D47A1"
            /> -->

        </v-tabs-items>

        <v-divider></v-divider>

        <v-card-actions>
            <v-btn
                outlined
                class="btn-danger"
                @click="cancel"
            >
                取消
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn
                outlined
                class="btn-primary"
                @click="updateStaffInfo"
            >
                更新
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>

import { mapGetters } from 'vuex'

import ManageAdministrationPermissions from './Tab/ManageAdministrationPermissions.vue';
// import ApiAuth from '@/views/Tab/ApiAuth.vue';
import {
   apiGetAuths,
   apiGetStaffInfo,
   apiUpdateStaffRole,
   apiUpdateAuth
} from '@/api/organize.js'

export default {
    components: { 
        ManageAdministrationPermissions,
        // ApiAuth
    },
    name: "StaffEdit",
    data() {
        return {
            is_load_data: false,
            card_title: '管理員資訊',
            card_sub_title_name: '名稱',
            card_sub_title_email: '電郵',
            card_sub_title_role: '角色',
            admin_edit_tabs: [
                {
                    title: '管理後台權限',
                    text: '管理後台權限',
                },
                // {
                //     title: 'API Auth',
                //     text: "API Auth"
                // },
                // {
                //     title: '訊息中心'
                // },
                // {
                //     title: 'POS權限'
                // },
                // {
                //     title: 'Optilytics權限'
                // },
                // {
                //     title: '社交電商權限'
                // },
                // {
                //     title: '智慧廣告系統'
                // },
                // {
                //     title: 'Optimize Payments帳戶權限'
                // },
                // {   
                //     title: '內嵌客製表單'
                // }
            ],
            tab: null,
            auth_items: [],
            staff_info: null,
            staff_role: null,
            staff_id: '',
            roles: [
                // 可以加人
                // 可以調別人的權限
                {
                    text: "管理員",
                    value: 1,
                },
                // 不能調別人的權限
                // 不可以加人
                {
                    text: "一般成員",
                    value: 2,
                }
            ],
        }
    },
    created: async function(){

        this.staff_id = parseInt(this.$route.params.staff_id)

        // 這裡會拿到這個user啟用了哪些api的紀錄
        this.staff_info = await this.getStaffInfo(this.staff_id)
        
        if (!this.staff_info || !this.staff_id) {
            this.$router.push(`/${this.selectedOrg.org_id}/setting/staffs/`)
        }

        // 這裏拿到這個人是admin還是一般成員
        this.staff_role = this.getTargetStaffRole(this.selectedAdmin)

        // 這裏拿到總共有哪些API
        this.auth_items = await this.getAuths()

        // 把哪些api有啟用變成一個mapppper
        let api_activate_mapper = {}
        this.staff_info.user_auth.forEach(function(auth){
            api_activate_mapper[auth.api_id] = auth.enable
        })

        // 然後再用拿到所有的api跑一次哪些是啟用之後，丟過去權限列表就可以讓他勾起來
        this.auth_items.forEach(function(auth_item){
            if (api_activate_mapper[auth_item.id]) {
                auth_item['enable'] = api_activate_mapper[auth_item.id]
            }
            else {
                auth_item['enable'] = false
            }
            
        })

        this.staff_info['role'] = this.staff_role
        console.log('this.selectedOrg',this.selectedOrg)
        console.log('this.staff_info', this.staff_info);
        console.log('this.auth_items', this.auth_items);
        console.log('this.staff_role', this.staff_role)

        // 設定麵包屑顯示選擇的人！
        this.$store.commit('update_breadcrumbs',[
            {
                "text": "設定",
                disabled: true,
            },
            {
                "text": "管理員",
                disabled: false,
                href: `/${this.$route.params.org_id}/setting/staffs/`
            },
            {
                "text": this.staff_info.user_name,
            }
        ])
        // this.updateBreadcrumbs("設定","管理員",this.staff_info.user_name )

        this.is_load_data = true
    },
    mounted() {
        console.log(this.tab)
    },
    methods: {
        async getAuths() {
            console.log(this.selectedOrg.org_id);
            let result
            result = await apiGetAuths(this.selectedOrg.org_id)
            .then(resp => {
                console.log(resp);
                return resp['data']['data']
            })
            .catch(error => {
                console.log(error);
                return []
            })
            return result
        },
        async getStaffInfo(staff_id) {
            let result = await apiGetStaffInfo(staff_id, this.selectedOrg.org_id)
            .then( resp  => {
                return resp.data.data
            })
            .catch( error => {
                console.log(error);
                return null
            })
            return result
        },
        updateBreadcrumbs(...names) {
            const breadcrumbs = names.map(name => ({ text: name }));
            this.$store.commit('update_breadcrumbs', breadcrumbs);
        },
        getTargetStaffRole: function(target_staff_info){
            let role = 2
            if (target_staff_info.is_admin) {
                role = 1
            }
            return role
        },
        updateRole: function(e){
            this.$refs['auth-tab'].changeRoleCallBack(e.value)
        },
        updateStaffInfo: async function(){
            let that = this
            const display_api_category = this.$refs['auth-tab'].display_api_category
            const other_auths = this.$refs['auth-tab'].other_auths
            console.log('parent', display_api_category)
            console.log('other', other_auths)
            let all_apis = []
            const category_keys = Object.keys(display_api_category)
            category_keys.forEach(function(category_key){
                let feature_keys = Object.keys(display_api_category[category_key]) 
                feature_keys.forEach(function(feature_key){
                    all_apis = all_apis.concat(display_api_category[category_key][feature_key])
                })
            })
            console.log('all_apis', all_apis)
            all_apis = all_apis.concat(other_auths)
            console.log('all_apis', all_apis)

            // 先更新使用者身份
            console.log(this.staff_role)
            let param = {
                "user_id": this.staff_id,
                "role_id": this.staff_role
            }
            if (this.staff_role.value){
                param['role_id'] = this.staff_role.value
            }

            console.log(param)

            await apiUpdateStaffRole(
                this.selectedOrg.org_id, param
            ).then(function(){
            }).catch(function(error){
                that.$root.vtoast.show({
                    message: '更新角色失敗，原因:' + (error.response ? JSON.stringify(error.response.data) : error)
                })
            })

            all_apis = all_apis.filter(function(api){
                // id 11 以下不能傳過去，因為跟api沒關
                return api.id >= 11
            })


            // 再更新使用者API權限
            if (param.role_id !== 1){
                param = {
                    "apis": all_apis,
                    "user_id": this.staff_id
                }
                await apiUpdateAuth(
                    this.selectedOrg.org_id,
                    param
                ).then(function(){
                }).catch(function(error){
                    that.$root.vtoast.show({
                        message: '更新權限失敗，原因:' + (error.response ? JSON.stringify(error.response.data) : error)
                    })
                })
            }

            console.log('???????????????')

            this.$root.vtoast.show({
                message: '更新成員資料成功',
                color: 'primary'
            })

            this.$router.push(`/${this.selectedOrg.org_id}/setting/staffs`)
        },
        cancel: function(){
            this.$router.push(`/${this.selectedOrg.org_id}/setting/staffs`)
        }
    },
    computed: {
        ...mapGetters(["selectedAdmin","selectedOrg",]),
    },
}
</script>

<style scoped>
    .fw-700{
        font-weight: 700;
        color: #000000;
    }
</style>